import { useUpdatedRef } from '@sail/react';
import { once } from '@sail/utils';
import { useMemo } from 'react';
import { UninitializedObservabilityProviderError } from '../internal/common/errors';
import logErrorInDev from '../internal/common/logErrorInDev';
import { useObservabilityApi } from '../internal/provider/ObservabilityApiProvider';
const logUninitializedErrorOnce = once(()=>{
    logErrorInDev(new UninitializedObservabilityProviderError('useMetrics'));
});
/**
 * @see https://sail.stripe.me/apis/observability/useMetrics
 */ export default function useMetrics() {
    const apiRef = useUpdatedRef(useObservabilityApi());
    return useMemo(()=>{
        // eslint-disable-next-line react-hooks/refs
        if (!apiRef.current) {
            logUninitializedErrorOnce();
        }
        return {
            increment (...args) {
                var _apiRef_current;
                return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.metrics.increment(...args);
            },
            gauge (...args) {
                var _apiRef_current;
                return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.metrics.gauge(...args);
            },
            set (...args) {
                var _apiRef_current;
                return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.metrics.set(...args);
            }
        };
    }, [
        apiRef
    ]);
}

//# sourceMappingURL=useMetrics.js.map